import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/finish-email-validation',
      name: 'finish-email-validation',
      component: () =>
        import('@/views/PageFinishValidation')
    },
    {
      path: '/home',
      name: 'home',
      props: true,
      component: () =>
        import('@/views/PageHome')
    },
    // user
    {
      path: '/@user/:uid',
      redirect: '/user/:uid'
    },
    {
      path: '/user/:uid/:tab?/:subTab?',
      name: 'user',
      props: true,
      component: () =>
        import('@/views/PageUser')
    },
    {
      path: '/edit-profile',
      name: 'edit-user',
      props: true,
      component: () =>
        import('@/views/PageEditProfile')
    },
    {
      path: '/account-settings',
      name: 'account-settings',
      props: true,
      component: () =>
        import('@/views/PageAccountSettings')
    },
    // post
    {
      path: '/@post/:postId',
      redirect: '/post/:postId'
    },
    {
      path: '/post/:postId',
      name: 'post',
      props: true,
      component: () =>
        import('@/views/PagePost')
    },
    {
      path: '/post-comment/:postId',
      name: 'post-comment',
      props: true,
      component: () =>
        import('@/views/PagePost')
    },
    // comic
    {
      path: '/@comic/:comicId',
      redirect: '/comic/:comicId'
    },
    {
      path: '/comic/:comicId',
      name: 'comic',
      props: true,
      component: () =>
        import('@/views/PageComic')
    },
    // asset
    {
      path: '/@asset/:assetId',
      redirect: '/asset/:assetId'
    },
    {
      path: '/asset/:assetId',
      name: 'asset',
      props: true,
      component: () =>
        import('@/views/PageAsset')
    },
    {
      path: '/edit-asset/:assetId',
      name: 'edit-asset',
      props: true,
      component: () =>
        import('@/views/PageEditAsset')
    },
    // edit-comic
    {
      path: '/edit-comic/:comicId?',
      name: 'edit-comic',
      props: true,
      component: () =>
        import('@/views/PageEditComicProfile')
    },
    {
      path: '/edit-comic/:comicId/episodes',
      name: 'comic-episodes',
      props: true,
      component: () =>
        import('@/views/PageEditComicEpisodes')
    },
    {
      path: '/edit-comic/:comicId/:episodeId/:pageId',
      name: 'edit-page',
      props: true,
      component: () =>
        import('@/views/PageEditPage')
    },
    {
      path: '/edit-comic/:comicId/:episodeId/:pageId/:frameId',
      name: 'edit-frame',
      props: true,
      component: () =>
        import('@/views/PageStudio')
    },
    {
      path: '/edit-comic/:comicId/:episodeId/:pageId/:frameId/drawing',
      name: 'edit-frame-by-drawing',
      props: true,
      component: () =>
        import('@/views/PageEditFrameByDrawing')
    },

    {
      path: '/others',
      name: 'others',
      props: true,
      component: () =>
        import('@/views/PageOthers')
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      props: true,
      component: () =>
        import('@/views/PageSignIn')
    },
    {
      path: '/sign-in/:redirectPath',
      name: 'sign-in',
      props: true,
      component: () =>
        import('@/views/PageSignIn')
    },
    {
      path: '/sign-up',
      name: 'sign-up',
      props: true,
      component: () =>
        import('@/views/PageSignIn')
    },
    {
      path: '/sign-up/:redirectPath',
      name: 'sign-up',
      props: true,
      component: () =>
        import('@/views/PageSignIn')
    },

    // for admin
    {
      path: '/admin/pose-generator/:poseId?',
      name: 'pose-generator',
      props: true,
      component: () =>
        import('@/views/admin/PagePoseGenerator')
    },
    {
      path: '/admin/poses',
      name: 'pose-generator',
      component: () =>
        import('@/views/admin/PagePoses')
    },

    // for demo
    {
      path: '/demo/test-scene',
      name: 'demo-test-scene',
      component: () =>
        import('@/views/PageDemoTestScene')
    },
    // {
    //   path: '/demo/test-scene2',
    //   name: 'demo-test-scene2',
    //   component: () =>
    //     import('@/views/PageDemoTestScene2')
    // },
    // {
    //   path: '/demo/convert',
    //   name: 'demo-convert',
    //   component: () =>
    //     import('@/views/PageDemoConvert')
    // },
    // {
    //   path: '/demo/studio',
    //   name: 'demo-studio',
    //   component: () =>
    //     import('@/views/PageDemoStudio')
    // },
    // {
    //   path: '/demo/jojo',
    //   name: 'demo-jojo',
    //   component: () =>
    //     import('@/views/PageDemoStudioJoJo')
    // },

    // top
    {
      path: '/:tab?/:subTab?',
      name: 'top',
      props: true,
      component: () =>
        import('@/views/PageTop')
    },

    // redirect
    {
      path: '*',
      redirect: '/'
    }
  ]
})
